










import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
    }
})
@Component
export default class DadosNumeroCartao extends Vue {


    get numerocartao () {
        return this.$store.state.cotacao.numerocartao;
    }

    set numerocartao ( value ) {
        this.$store.commit("SET_NUMEROCARTAO", value);
    }

    get errorNumeroCartao () {
        return this.$store.state.errors.numerocartao;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
